<template>
  <div :class="classObj" class="app-wrapper">
    <!--<div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />-->
    <sidebar
      :class="['sidebar-container', { 'sidebar-pos': hShow }]"
      :style="isLeftShow ? 'width:180px' : 'width:60px'"
      v-if="isHideSidebar"
    />
    <div
      v-if="isHideSidebar"
      class="clickLeftDisplay"
      :style="isLeftShow ? 'left:20px' : ''"
      @click="clickDisplayLeft"
    >
      <i v-if="isLeftShow" class="el-icon-d-arrow-left">
        <span class="arrow-left-test">{{ $t('layoutIndex.collapseMenuBar') }}</span>
      </i>
      <i v-if="!isLeftShow" class="el-icon-d-arrow-right"></i>
    </div>
    <div v-if="isLeftShow" class="moreClick" @click="clickDisplayLeft"></div>
    <div
      class="main-container"
      :style="isHideSidebar ? (isLeftShow ? 'margin-left:180px' : 'margin-left:60px') : '0px'"
    >
      <div v-if="hShow" :class="[{ 'fixed-header': fixedHeader }, { 'header-width': hShow }]">
        <div class="fixed-header-wrapper">
          <div class="header-title">{{ $t('common.member') }}</div>
          <!--          <img v-if="!$route.query.from" class="close-btn" src="@/assets/icon-close.png" alt="" @click.self="closePage">-->
        </div>
      </div>
      <!-- 首次登录弹框 -->
      <!-- <LoginFirstNotice /> -->
      <div v-if="!hShow" :class="{ 'fixed-header': fixedHeader }">
        <navbar :isHeaderShow="isHeaderShow" :isHideSidebar="isHideSidebar" />
        <SideMessage v-show="shouldShowSideMessage" :visible="shouldShowSideMessage"></SideMessage>
      </div>
      <app-main />
      <Statistics />
    </div>
    <AiFloatEntry />
    <AiNoticeNotifier />
    <Notification />
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, SideMessage, Notification, Statistics, AiFloatEntry, AiNoticeNotifier } from './components';
import ResizeMixin from './mixin/ResizeHandler';

export default {
  name: 'Layout',
  components: {
    Notification,
    Navbar,
    Sidebar,
    AppMain,
    SideMessage,
    Statistics,
    AiFloatEntry,
    AiNoticeNotifier,
    // LoginFirstNotice: () => import('./components/loginFirstNotice.vue'),
  },
  mixins: [ResizeMixin],
  computed: {
    isHeaderShow() {
      return !this.$route.meta.hidden;
    },
    shouldShowSideMessage() {
      return this.isHeaderShow;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    isLeftShow() {
      return this.$store.state.app.isDisplayLeftMenu;
    },
    classObj() {
      return {
        hideSidebar: false,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
      };
    },
    hShow() {
      return this.$route.query.hShow;
    },
    //隐藏左侧菜单
    isHideSidebar() {
      let arr = ['/home-page/index'];
      return arr.indexOf(this.$route.path) == -1;
    },
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
    },
    closePage() {
      window.close();
    },
    clickDisplayLeft() {
      this.$store.commit('app/Set_is_Display_Left_Menu', !this.isLeftShow);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1180px;

  //overflow: hidden;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }

  .clickLeftDisplay {
    position: fixed;
    top: 64px;
    left: 0;
    z-index: 80;
    height: 30px;
    width: auto;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 1;

    img {
      width: 20px;
      height: 20px;
    }

    .arrow-left-test {
      position: relative;
      top: -1px;
      margin-left: 12px;
      font-size: 12px;
      font-weight: 300;
    }

    .el-icon-d-arrow-right {
      margin-left: 22px;
    }

    .el-icon-d-arrow-right:hover {
      color: #0f93ff;
    }

    .el-icon-d-arrow-left:hover {
      color: #0f93ff;
    }
  }

  .moreClick {
    position: fixed;
    top: 60px;
    left: 0;
    z-index: 60;
    height: 35px;
    width: 130px;
    cursor: pointer;
  }

  .sidebar-pos {
    padding-top: 10px;
    top: 50px;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100%);
  z-index: 20;
  transition: width 0.28s;
}

.header-width {
  width: 100%;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}

.fixed-logo-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 162px;
  height: 48px;
  background: rgba(44, 59, 78, 1);
  display: flex;

  .sidebar-logo {
    width: 86px;
    height: 42px;
    margin: auto;
  }
}

.main-container {
  &.no-sider {
    margin-left: 0 !important;
  }
}
</style>
